import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TITLE_SEARCH_MATTER_STATE } from '@models/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { ICON } from '@core/util/icon';
import { TestHooks } from './footer.hooks';

@Component({
	selector: 'app-teranet-stepper-footer',
	templateUrl: './footer.component.html',
	standalone: false,
})
export class TeranetStepperFooterComponent {
	testHooks = TestHooks;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	ICON = ICON;
	@Input() showBack = true;
	@Input() nextLabel = 'Continue';
	@Input() showSkip = true;

	// rome-ignore lint/suspicious/noExplicitAny: <explanation>
	@Output() onNext: EventEmitter<any> = new EventEmitter();
	// rome-ignore lint/suspicious/noExplicitAny: <explanation>
	@Output() onBack: EventEmitter<any> = new EventEmitter();

	constructor(private matterDispatch: MatterDispatch) {}

	back(): void {
		this.onBack.emit();
	}

	next(): void {
		this.onNext.emit();
	}

	skip(): void {
		this.matterDispatch.SetTitleState(
			this.matterId,
			TITLE_SEARCH_MATTER_STATE.COMPLETE,
		);
	}
}
